import React, { useEffect, useState } from "react";
import { Button, Col, Container, ListGroup, Row } from "react-bootstrap";
import useLoader from "../../contexts/LoaderContext";
import { useCart } from "../../services/cartService";
import { useHeaderMenu } from "../../contexts/login.context";
import nvCookieHelpers from "../../services/cookieService";
import { useNavigate } from "react-router-dom";
import './PayPalError.scss';
import { useTranslation } from "react-i18next";
const PayPalError: React.FC = () => {
    const navigate = useNavigate();
    const { showBodyLoader, hideBodyLoader } = useLoader();
    const { getCart } = useCart();
    const { setItemsInCart } = useHeaderMenu();
    const [displayNames, setDisplyNames] = useState<[] | undefined>();
    const locale = window.location.pathname.split('/')[1];
    const { t } = useTranslation();
    const emptyCart = (msg: string) => navigate(`/${locale}/software/cart/empty`, { state: { msg } });
    const handleSuccess = (result) => {
        if (result.totalItemsInCart > 0) {
            const newDisplayNames = result.cartItems?.cartItem.map((item: any) => item.product.displayName) || [];
            setItemsInCart(result.totalItemsInCart);
            setDisplyNames(newDisplayNames);
        } else {
            emptyCart(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
        }
        hideBodyLoader();
    }
    const handleError = () => {
        setItemsInCart(0);
        emptyCart(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
        hideBodyLoader();
    };
    const fetchCart = async () => {
        showBodyLoader();
        await getCart(handleSuccess, handleError,false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    };
    const handleBackClick = () => {
        if (nvCookieHelpers.getCookie('isUserLoggedIn')) {
            navigate(`/${locale}/software/cart/user/loggedIn`)
        } else {
            navigate(`/${locale}/software/cart/user/guest`)
        }
    }
    useEffect(() => {
        fetchCart();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <div className="PayPalError">
            <Container>
                <Row xs={'auto'} md={'auto'}>
                    <Col md={12}>
                        <h3 className="errorHeading">cart and billing info</h3>
                        <div className="errorInfo mt-2">
                            <p className="bold">The following products are restricted by shipping country specified.</p>
                        </div>
                        <div className="errorDescription mt-4">
                            <p>You may go back and change you shipping information, or you may continue with your specified shipping country and have the following items removed from your order:</p>
                            <ListGroup as="ol" className="mb-5">
                                {displayNames?.map((displayName: string, index: number) => (
                                    <li key={index}>{displayName}</li>
                                ))}
                            </ListGroup>
                        </div>
                    </Col>
                    <Col md={6} className="ctaSection">
                        <b>Update Address Information:</b>
                        <p>Go back and update my address information</p>
                        <Button type="button" variant="success" className="mt-4 btn-green" onClick={handleBackClick}>Back</Button>
                    </Col>
                    <Col md={6} className="ctaSection">
                        <b>Modify Order:</b>
                        <p>Delete these products from my order</p>
                        <Button type="button" variant="success" className="mt-4 btn-green" onClick={()=>emptyCart(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'))}>Submit</Button>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export default PayPalError;